import { DEFAULT_DIVERGENCE_REASON } from '@/constants/ds-attendance.constants'

/**
 * Frente E/Q20 — regra única de "branco vira default": o texto aparado, ou o default de
 * antes do preset quando vazio/ausente. A trilha nunca ganha linha divergente sem motivo.
 */
export function normalizeDivergenceReason(text: string | undefined): string {
  return text?.trim() || DEFAULT_DIVERGENCE_REASON
}

/**
 * Frente E/Q20 — o texto que vai em `divergenceReason` para a linha `rowIndex`. Texto em
 * branco nunca é gravado: cai no default de antes do preset, para a trilha não ganhar
 * linhas divergentes sem motivo.
 */
export function resolveDivergenceReason(
  divergenceReasons: Record<number, string>,
  rowIndex: number
): string {
  return normalizeDivergenceReason(divergenceReasons[rowIndex])
}
